// extracted by mini-css-extract-plugin
export default {"HyperLinks":"HyperLink_HyperLinks__T9HYz"};